import React, { useContext } from "react";
import Row from "@amzn/meridian/row";
import ButtonGroup, { ButtonOption } from "@amzn/meridian/button-group";
import { PVAOverviewContext } from "../overview/context/PVAOverviewContext";
import { FormattedMessage } from "react-intl";
import PackageOverviewInbound from "./PackageOverviewInbound";
import PackageOverviewOutbound from "./PackageOverviewOutbound";

const PackageOverview = (props) => {
  const { pvaData, dispatch } = useContext(PVAOverviewContext);
  return (
    <Row
      maxWidth="100%"
      width="100%"
      widths={["grid-12"]}
      spacingInset="none large"
    >
      <div>
        <ButtonGroup
          value={pvaData.pvaTableData.granularity}
          onChange={(value) =>
            dispatch({
              type: "CHANGE_GRANULARITY",
              data: { granularity: value },
            })
          }
        >
          <ButtonOption value="15">
            <FormattedMessage
              id="package_overview.min15"
              defaultMessage="15 min"
            />
          </ButtonOption>
          <ButtonOption value="30">
            <FormattedMessage
              id="package_overview.min30"
              defaultMessage="30 min"
            />
          </ButtonOption>
          <ButtonOption value="60">
            <FormattedMessage
              id="package_overview.min60"
              defaultMessage="1 hour"
            />
          </ButtonOption>
          <ButtonOption value="cumulative">
            <FormattedMessage
              id="package_overview.cumulative"
              defaultMessage="Cumulative"
            />
          </ButtonOption>
        </ButtonGroup>
        {pvaData.overviewData.flowPVAData || pvaData.pick.flowPVAData ? (
          <Row
            width="100%"
            widths="fill"
            className="enable-scroll-x"
            spacingInset="medium none none none"
          >
            {props.view.processName === "inbound" ? (
              <PackageOverviewInbound />
            ) : null}
            {props.view.processName === "outbound" ? (
              <PackageOverviewOutbound />
            ) : null}
          </Row>
        ) : (
          ""
        )}
      </div>
    </Row>
  );
};

export default PackageOverview;



// WEBPACK FOOTER //
// ./src/components/packageOverview/PackageOverview.js